export const SECURPOINT_APP_DEEP_LINK = "securpoint://";
export const SECURPOINT_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.securpoint.securpoint";
export const SECURPOINT_APP_STORE_URL =
  "https://apps.apple.com/us/app/securpoint/id6754969358";

const getDeviceType = () => {
  const userAgent = navigator.userAgent || navigator.vendor || "";

  if (/android/i.test(userAgent)) {
    return "android";
  }

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return "ios";
  }

  return "other";
};

export const getSecurPointStoreUrl = () => {
  const deviceType = getDeviceType();

  if (deviceType === "android") {
    return SECURPOINT_PLAY_STORE_URL;
  }

  if (deviceType === "ios") {
    return SECURPOINT_APP_STORE_URL;
  }

  return SECURPOINT_PLAY_STORE_URL;
};

// export const openSecurPointApp = () => {
//   const storeUrl = getSecurPointStoreUrl();
//   let appOpened = false;

//   const markAppOpened = (event) => {
//     if (document.hidden || event?.type === "blur" || event?.type === "pagehide") {
//       appOpened = true;
//     }
//   };

//   const cleanup = () => {
//     document.removeEventListener("visibilitychange", markAppOpened);
//     window.removeEventListener("pagehide", markAppOpened);
//     window.removeEventListener("blur", markAppOpened);
//   };

//   document.addEventListener("visibilitychange", markAppOpened);
//   window.addEventListener("pagehide", markAppOpened);
//   window.addEventListener("blur", markAppOpened);

//   window.location.href = SECURPOINT_APP_DEEP_LINK;

//   window.setTimeout(() => {
//     cleanup();

//     if (!appOpened && !document.hidden) {
//       window.location.href = storeUrl;
//     }
//   }, 1500);
// };

export const openSecurPointApp = () => {
  const start = Date.now();

  window.location.href = "https://securpoint.app";

  setTimeout(() => {
    const isAndroid = /Android/i.test(navigator.userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    // Only fallback if app didn't open
    if (Date.now() - start < 2500) {
      if (isAndroid) {
        window.location.href = SECURPOINT_PLAY_STORE_URL;
      } else if (isIOS) {
        window.location.href = SECURPOINT_APP_STORE_URL;
      }
    }
  }, 2000);
};
